import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ReactSVG } from "react-svg";
import logo from "../../../../assets/images/layout/wlh-header-logo.svg"
import { Tabs, UserInformation, NotificationBanner } from "./components";
import { changeActiveChoice } from "../../../../reducers/active-choice";
import { resetUnsavedChanges, selectHasUnsavedChanges } from "../../../../reducers/settings";
import SaveSettingsChangesAlert from "../../../pages/Settings/save-changes-alert";
import { AdminUserAgent } from "../../../../api/adminUserAgent";
import { setCandidateMessageReply } from "../../../../reducers/notifications";
import { setDetailsDialogUnsavedChanges } from "../../../../reducers/positions";
import { ApplicationRoutes } from "../../../constants";
import { useInterviewNavigationGuard } from "../../../company/interview-builder/interview-navigation-guard";

const Header = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [showBanner, setShowBanner] = useState(false);
    const [isMenuDisabled, setMenuDisabled] = useState(false);
    const [isMessageAlertOpen, setIsMessageAlertOpen] = useState(false); 
    const hasUnsavedChanges = useSelector(selectHasUnsavedChanges);
    const { hasDetailsDialogUnsavedChanges } = useSelector((state) => state.vacanciesReducer);
    const { activeChoice } = useSelector((state) => state.activeChoice)
    const [nextUrl, setNextUrl] = useState(null);
    const [nextAction, setNextAction] = useState(null);
    const [notifications, setNotifications] = useState([]);
    const { refreshNotificationsTrigger } = useSelector((state) => state.notifications);
    const { requestInterviewNavigation } = useInterviewNavigationGuard();

    const fetchAllNotifications = async () => {
        const token = window.localStorage.getItem("token");
        
        try {
          const { data } = await AdminUserAgent.getAllNotifications(token);
          setNotifications(data);
          const candidateMessageReplies = {};
          data.forEach(notification => {
              if (notification.entity_type === "Message" && !notification.is_read) {
                  const candidateId = notification.candidate_id;
                  if (!candidateMessageReplies[candidateId]) {
                      candidateMessageReplies[candidateId] = {
                          notificationId: notification.id,
                          hasUnreadMessage: true,
                          messageType: notification.message_type,
                          vacancyId: notification.vacancy_id
                      };
                  }
              }
          });
          dispatch(setCandidateMessageReply(candidateMessageReplies));
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        fetchAllNotifications();
    }, [showBanner, activeChoice, refreshNotificationsTrigger])

    const showNotificationBanner = () => {
        setShowBanner(!showBanner);
    };

    const handleNavigation = (url, action) => {
        requestInterviewNavigation(() => {
            if (hasUnsavedChanges || hasDetailsDialogUnsavedChanges) {
                setNextUrl(url);
                setNextAction(action);
                setIsMessageAlertOpen(true);
                return;
            }
            dispatch(action);
            navigate(url);
        });
    };

    const handleConfirm = () => {
        dispatch(resetUnsavedChanges());
        dispatch(setDetailsDialogUnsavedChanges(false));
        if (nextAction && nextUrl) {
            dispatch(nextAction);
            navigate(nextUrl);
        }
    };

    return (
        <>
            <header className="bg-white min-h-[80px] rounded-[97px] shadow-[0px_3px_3px_rgba(0,0,0,0.161)] flex justify-between mx-10 my-6 items-center relative z-30">
                <div onClick={() => handleNavigation(ApplicationRoutes.hi5Root, changeActiveChoice("Searches"))} className="flex items-center h-full">
                    <ReactSVG src={logo} className="pl-5 cursor-pointer [&_svg]:w-[236px] [&_svg]:h-auto" />
                </div>
                <Tabs isMenuDisabled={isMenuDisabled} handleNavigation={handleNavigation} />
                <UserInformation
                  isNotificationActive={notifications?.find((notification) => !notification.is_read && notification.message_type !== "linkedin" )}
                  setMenuDisabled={setMenuDisabled} 
                  showNotificationBanner={showNotificationBanner} 
                />
                {showBanner && (
                    <NotificationBanner 
                      showNotificationBanner={showNotificationBanner} 
                      notifications={notifications}
                    />
                )}
            </header>
            <SaveSettingsChangesAlert 
                isMessageAlertOpen={isMessageAlertOpen} 
                setIsMessageAlertOpen={setIsMessageAlertOpen}
                handleConfirm={handleConfirm}
            />
        </>
    );
};


export default Header;
